import React from 'react';
import PropTypes from 'prop-types';
import { toConciseSpend } from 'utilities/string';

export const channelDimensionProps = PropTypes.shape({
  adFormat: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentType: PropTypes.arrayOf(PropTypes.string).isRequired,
  placement: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export const dateOptionStorageKey = 'creativeCampaignsDate';
export const filterStorageKey = 'creativeCampaignsFilters';

export function renderSpendMetric(label, value) {
  return (
    <div className="u-flexColumn u-gap-8">
      <div className="t-label-1">{ label }</div>
      <h5>{ value ? toConciseSpend(value) : 'N/A' }</h5>
    </div>
  );
}
